<template>
  <span class="field_inner">
    <app-select
      id="denOd"
      v-model="selectedDate"
      :options="generated.dates"
      @change="onDateChanged"
    />
    <app-select
      id="casOd"
      v-model="selectedHour"
      :options="generated.hours"
      @change="onHourChanged"
    />
    <a class="now" type="button" :title="$gettext(this.resetTimeString)" @click="$emit('resetTime')">{{$gettext(this.resetTimeString)}}</a>
  </span>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'app-date-since',
  props: {
    currentTimestamp: {
      type: Object,
      default: null
    },
    startDate: {
      type: Number | String,
      required: true
    },
    endDate: {
      type: Number | String,
      required: true
    },
    resetTimeString: {
      type: String,
      default: 'Aktuální čas'
    }
  },
  created() {
    this.loadDate(this.currentTimestamp)
  },
  data() {
    return {
      selectedDate: null,
      selectedHour: 0
    }
  },
  computed: {
    generated() {
      const currentTimestamp = moment()
      const date = moment.unix(this.startDate).minute(0)
      const endDate = moment.unix(this.endDate)
      const hours = []
      const dates = []

      for (let i = 0; i < 24; i++) {
        date.hour(i)
        hours.push({
          name: date.format('H:mm'),
          value: i
        })
      }

      while (endDate.isAfter(date, 'day')) {
        dates.push({
          date: date.clone(),
          name: date.format(currentTimestamp.isSame(date, 'day') ? `[${this.$gettext('Dnes')}] D. M.` : 'ddd D. M.'),
          value: date.toISOString()
        })
        date.add(1, 'days')
      }

      return {
        dates,
        hours
      }
    }
  },
  methods: {
    loadDate(d) {
      if (this.generated.dates.length > 0) {
        const date = moment(d || moment().toISOString())
        const index = this.generated.dates.findIndex(v => v.date.isSame(date, 'day'))
        this.selectedDate = this.generated.dates[index === -1 ? 0 : index].value
        this.selectedHour = moment(this.currentTimestamp).hour()
      }
    },
    onDateChanged() {
      this.$emit('dateChanged', this.selectedDate)
    },
    onHourChanged() {
      this.$emit('hourChanged', this.selectedHour)
    }
  },
  watch: {
    generated() {
      this.loadDate(this.currentTimestamp)
    },
    currentTimestamp() {
      this.loadDate(this.currentTimestamp)
    }
  }
}
</script>
